import "./instrument";
import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import reportWebVitals from "./reportWebVitals";
import { registerFonts } from "@controllers/FontService";

registerFonts();

// Corporate proxies sometimes append query parameters (e.g. ?_sm_nck=1) to script
// URLs, causing webpack chunk requests to 403. A single automatic reload is enough
// because the proxy usually drops the nonce on subsequent requests, or the chunk
// is served from the browser cache. The flag prevents an infinite reload loop.
window.addEventListener("unhandledrejection", (event) => {
  const isChunkError =
    event.reason?.name === "ChunkLoadError" ||
    (typeof event.reason?.message === "string" && event.reason.message.includes("Loading chunk"));

  if (isChunkError) {
    event.preventDefault();
    const reloadKey = "pf-chunk-reload";
    if (!sessionStorage.getItem(reloadKey)) {
      sessionStorage.setItem(reloadKey, "1");
      window.location.reload();
    }
  }
});

const container = document.getElementById("root");
const root = createRoot(container!);

root.render(<App />);
// root.render(
//   <React.StrictMode>
//     <App />
//   </React.StrictMode>
// );

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
